import React, { useEffect, useState } from 'react';
import { FaSearch, FaYoutube } from "react-icons/fa";
import { Link, useNavigate, useParams } from 'react-router-dom';
import './SearchHeader.css';

export default function SearchHeader() {
    const { keyword } = useParams();
    const navigate = useNavigate();
    const [text, setText] = useState('');
    const handleSubmit = (e) => {
        e.preventDefault();
        navigate(`/videos/${text}`); // 경로로 이동한다.
    };
    useEffect(() => setText(keyword || ''), [keyword]) 
    // keyword가 변경될 때마다 함수를 실행해준다.

    return (
        <header className='w-100 d-flex p-3 border-bottom border-secondary'>
            {/* 로고 부분과 form부분을 나누어서 작업하기 */}
            <Link to='/' className='d-flex align-items-center' style={{ textDecoration: 'none', color: 'white'}}>
                <FaYoutube className='fs-1' style={{color: '#ff0033'}} />
                <h1 className='fw-bold p-2'>Youtube</h1>
            </Link>
            <form className='w-100 d-flex p-2 mt-2 justify-content-center' onSubmit={handleSubmit}>
                <input className='no-focus-outline p-2'  
                style={{width: '50%', backgroundColor:'black', 
                    color: '#f8f9fa7f'}} type="text" placeholder='Search...' 
                value={text} onChange={(e) => setText(e.target.value)}/>
                <button className='px-3 no-focus-outline' style={{backgroundColor: '#53525B', color: 'white' }}><FaSearch/></button>
            </form>
        </header>
    );
}

